import { useWindowSize } from "@/hooks";
import { useEffect, useState } from "react";
import { ImageAnnotation } from "@annotorious/react";
import { Box } from "@chakra-ui/react";
import { getIssueColor } from "./health_issues";

interface IAnnotationBadges {
  annotation: ImageAnnotation;
  imageElement: HTMLImageElement | null;
}

function AnnotationBadges({ annotation, imageElement }: IAnnotationBadges) {
  // This line is used to trigger a re-rendering of the component when the size
  // of the navigator windown changes
  useWindowSize();
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!imageElement) return;

    const updateSize = () => {
      setImageSize({
        width: imageElement.clientWidth,
        height: imageElement.clientHeight,
      });
    };

    // Set initial size
    updateSize();

    // Create a ResizeObserver to watch the image size changes
    const resizeObserver = new ResizeObserver(updateSize);
    resizeObserver.observe(imageElement);

    return () => resizeObserver.disconnect();
  }, [imageElement]);

  if (!imageElement) return null;
  
  const { left, top } = imageElement.getBoundingClientRect();
  const kx = imageSize.width / imageElement.naturalWidth;
  const ky = imageSize.height / imageElement.naturalHeight;
  const { minX, minY } = annotation.target.selector.geometry.bounds;
  return (
    <>
      {annotation.bodies.map((b, i) => (
        <Box
          key={b.id}
          position="absolute"
          top={{base: ky * minY - imageElement.offsetHeight - top + 48, sm: ky * minY - imageElement.offsetHeight - top + 88}}
          left={left + kx * minX + 4 + i * 6}
          height={3}
          width={3}
          borderRadius="full"
          bg={`${getIssueColor(b.id)}.300`}
          borderWidth="1px"
          borderStyle={b.value === "1.0" ? "solid" : "dashed"}
          borderColor={`${getIssueColor(b.id)}.700`}
        />
      ))}
    </>
  );
}

export default AnnotationBadges;
